import React, { createContext, useContext } from 'react'
import { isArray, pick } from 'lodash-es'
import { useStore } from 'zustand'
import shallow from 'zustand/shallow'

const Context = createContext()

const useDataOperateStore = (selectors, equalityFn = shallow) => {
  const store = useContext(Context)
  if (!store) {
    throw new Error('no provider')
  }
  if (isArray(selectors)) {
    return useStore(store, (x) => pick(x, selectors), equalityFn)
  }
  return useStore(store, selectors, equalityFn)
}

const DataOperateProvider = function ({ children, createStore: extendStore }) {
  return <Context.Provider value={extendStore}>{children}</Context.Provider>
}

export { DataOperateProvider, useDataOperateStore }
